import { EnviarSolicAnalise } from "./SolicitacaoAnalise";

export default EnviarSolicAnalise;